import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import { ALL_GUIDES, ALPHABETICAL_FOODS } from '../data/allFoods';

export const PRIMARY_GUIDES = [
  { slug: "saadan-fryser-du-mad", title: "Sådan fryser du mad rigtigt", desc: "Temperatur, lufttæt pakning, indfrysning og mærkning med dato." },
  { slug: "hvor-laenge-holder-mad-i-fryseren", title: "Hvor længe holder mad i fryseren?", desc: "Komplet tabel for kød, fisk, grønt, mejeri og færdigretter." },
  { slug: "optoening", title: "Optøning af mad", desc: "Hvorfor køleskabet er den sikreste metode, og hvordan du undgår bakterier." },
  { slug: "kan-man-genfryse", title: "Kan man genfryse mad?", desc: "Regler for råt og tilberedt kød, brød, kager og mejeriprodukter." }
];

export const OTHER_GUIDES = [
  { slug: "hvad-kan-man-ikke-fryse", title: "Hvad kan man ikke fryse?", desc: "Det, der mister struktur eller skiller på frost." },
  { slug: "fryse-i-glas", title: "Kan man fryse i glas og fade?", desc: "Sådan fryser du uden at glasset eller fadet revner." }
];

export default function Home() {
  return (
    <div className="space-y-12">
      <SeoMeta
        title="Kan man fryse mad? — Opslagsguide om frysning"
        metaTitle="Kan man fryse mad? — Uafhængig opslagsguide"
        metaDescription="Uafhængig dansk guide til frysning af mad: holdbarhed på frost, pakning, optøning og genfrysning for kød, ost, grønt og brød."
        slug=""
        isHome={true}
      />

      <section className="border-b border-[#DCE3EC] pb-8">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#141B22] mb-4">
          Kan man fryse …?
        </h1>
        <p className="text-lg text-[#5C6670] leading-relaxed">
          En uafhængig opslagsguide til frysning af mad. Svaret på om en råvare kan fryses, hvor længe den holder, hvordan den pakkes, og hvordan den tøs op igen.
        </p>
      </section>

      {/* Primære guider */}
      <section className="space-y-4">
        <h2 className="text-xs font-bold uppercase tracking-wider text-[#2A4DB0]">
          De vigtigste guider
        </h2>
        <div className="border border-[#DCE3EC] rounded-[6px] divide-y divide-[#DCE3EC] bg-white">
          {PRIMARY_GUIDES.map(guide => (
            <div key={guide.slug} className="p-4 sm:p-5 hover:bg-[#F5F8FB] transition-colors">
              <Link 
                to={`/${guide.slug}`}
                className="text-lg font-bold text-[#2A4DB0] hover:underline block mb-1"
              >
                {guide.title}
              </Link>
              <p className="text-sm text-[#5C6670] leading-relaxed">
                {guide.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Sekundære guider */}
        <div className="pt-2 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
          {OTHER_GUIDES.map(guide => (
            <div key={guide.slug} className="p-4 rounded-[6px] border border-[#DCE3EC] bg-white hover:bg-[#F5F8FB] transition-colors">
              <Link to={`/${guide.slug}`} className="font-semibold text-[#2A4DB0] hover:underline block mb-1">
                {guide.title}
              </Link>
              <p className="text-xs text-[#5C6670] leading-relaxed">
                {guide.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Alfabetisk A–Å indeks */}
      <section id="alfabetisk" className="space-y-6 pt-6 border-t border-[#DCE3EC]">
        <div>
          <h2 className="text-2xl font-bold text-[#141B22] mb-1">
            Fødevarer fra A til Å
          </h2>
          <p className="text-sm text-[#5C6670]">
            Slå en konkret råvare eller madret op og se holdbarhed, fryseegnethed og optøningsregler.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
          {ALPHABETICAL_FOODS.map(food => (
            <div key={food.slug} className="border-b border-[#DCE3EC] pb-2.5 flex items-baseline justify-between gap-3">
              <Link
                to={`/${food.slug}`}
                className="text-[15px] sm:text-[16px] font-semibold text-[#141B22] hover:text-[#2A4DB0] hover:underline transition-colors leading-snug"
              >
                {food.shortTitle || food.title.replace('?', '')}
              </Link>
              <span className="text-xs text-[#5C6670] whitespace-nowrap shrink-0">
                {food.table?.[0]?.duration || "Se guide"}
              </span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
